/** Passport SDK 仅由页面 HTML 中的 script 标签引入，禁止在 JS 中动态注入 script。 */
export const isPassportSdkReady = () =>
    typeof window !== 'undefined' &&
    typeof window.login?.setConfig === 'function' &&
    typeof window.login?.checkPhoneApi === 'function';

export const withReadyPassport = <T>(task: () => T | Promise<T>): Promise<T> => {
    if (!isPassportSdkReady()) {
        return Promise.reject(new Error('Passport SDK is not ready'));
    }

    return Promise.resolve(task());
};
